import {Fragment} from 'react'
import PropTypes from 'prop-types'

import {List} from "react-feather"

import './FreelancePageWrapper.scss'

export default function FreelancePageWrapper({children, className, style, onMobileCtaClick, hideLevel2Btn, ...props}) {
  const handleStyle = () => {
    const styleAttr = (style)? style : {}

    return {
      ...styleAttr,
    }
  }

  return (
    <Fragment>
      <div className={`fl-pages-wrapper ${className ? className : ''}`}  {...props} style={handleStyle()}>
        {!hideLevel2Btn &&
          <button className="toggle-mobile-menu-cta" onClick={onMobileCtaClick}>
            <div className="svg-wrapper">
              <List/>
            </div>
          </button>
        }
        {children}
      </div>
    </Fragment>
  )}

FreelancePageWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  className: PropTypes.string
}